import React from "react";
import  { useState, useEffect } from 'react';
import './classes/AgencyWebsiteandCommunications.css';
import { Link, useNavigate,useParams,useLocation } from 'react-router-dom';
import { configData } from "../config";
import { Helmet } from "react-helmet";
import Loading from './Loading';
import SalespersonSidebar from "./SalespersonSidebar";

const AgencyWebsiteandCommunications = () => {

    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        Promise.all([
            
        ])
        .then(() => {
        setIsLoading(false);
        })
     
    },[]);

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <div id="main" className="agency-communication-main">
                    <Helmet><title>SMWW Agency Player Websites</title></Helmet>
                    <div className="left"></div>
                    <div className="center left-center">
                        <div className="agency-communication-container">
                            <h1>Your Personalized Website &amp;&nbsp;Communications</h1>
                            <p>
                                <img className="imgfulli" align="right" src="/basic/web/images/agent/website-newmedia.jpg" />
                                Sports Management Worldwide Agency believes that every professional athlete has a fan base that follows them throughout their career. A loyal fan base starts in the athlete's hometown and grows with the athlete's success through college, through professional careers, and post-career. At SMWW, our job is to increase the brand of our clients off the field. As our client, we will create and maintain your brand as a professional athlete for maximum success. As an educational facility, we have access to cutting-edge techniques and experts in personalized websites, social media, and media training. Our goal at SMWW is to grow your brand, monetize your potential, and maximize every opportunity so that you can focus on your playing career.
                            </p>
                            <h2>Personalized Website:</h2>
                            <p>A personalized athlete website allows you to develop additional business opportunities and provide a forum to inform and increase your fan base. Athletes can earn additional income in many ways including sponsorship, commercials, speaking engagements, autograph sessions, product endorsements, personal appearances, personalized product sales, and modeling. Athletes can give back to society in multiple ways including foundations, nonprofit relationships, and donations. A personalized athlete website provides the foundation of the ongoing goal of marketing you, the professional athlete. Your website is the fastest way for your fans and businesses to contact you. Personal branding defines and sets the pace of your career path early on. Sports Management Worldwide Agency&nbsp;has a creative team of designers and marketing professionals who will create and maintain an interactive website for you.</p>
                            <h2>Social Media</h2>
                            <p>With the foundation of a website, our experts will assist you with all social media outlets. This includes Twitter, Tik Tok, YouTube, and Instagram. Athletes need to maintain an off the field presence of integrity and ethics and growing their brand for a lifetime. To increase search engine optimization and maximize long-term success, all social media outlets will be linked back to your personalized website. Our experts know what works and what doesn't work and they will help you design and/or redesign your social media tools. The intensity and media scrutiny that accompanies every word an athlete posts online in the 24/7 news cycle, along with the explosion of social networking, has greatly affected the perception of professional athletes. At SMWW Agency we will set you up for unparalleled success.</p>
                            <h2>&nbsp;</h2>
                        </div>
                    </div>
                    <div className="right">
                        <SalespersonSidebar />
                    </div>
                </div>        
            )}
        </>
    );
};
export default AgencyWebsiteandCommunications;